export type TRepositoriesListParams = {
  page: number;
  pageSize: number;
  search: string;
  from: string;
  to: string;
};

export const repositoriesKeys = {
  all: [{ module: 'repositories' }] as const,
  lists: () => [{ ...repositoriesKeys.all[0], scope: 'list' }] as const,
  listsByOrg: (organizationId: string) => [{ ...repositoriesKeys.lists()[0], organizationId }] as const,
  list: (organizationId: string, params: TRepositoriesListParams) =>
    [{ ...repositoriesKeys.listsByOrg(organizationId)[0], params }] as const,
  allByOrg: (organizationId: string) => [{ ...repositoriesKeys.listsByOrg(organizationId)[0], all: true }] as const,
  details: () => [{ ...repositoriesKeys.all[0], scope: 'detail' }] as const,
  detail: (repositoryId: string) => [{ ...repositoriesKeys.details()[0], repositoryId }] as const,
  organizationDetail: (organizationSlug: string, repositorySlug: string) =>
    [{ ...repositoriesKeys.details()[0], organizationSlug, repositorySlug }] as const,
  attachmentPlaybackUrls: () => [{ ...repositoriesKeys.all[0], scope: 'attachmentPlaybackUrl' }] as const,
  attachmentPlaybackUrl: (attachmentId: string) =>
    [{ ...repositoriesKeys.attachmentPlaybackUrls()[0], attachmentId }] as const,
};
